import createClient, { type Client } from "openapi-fetch";
import type { paths } from "@/generated/openapi-types";

export type AuthStrategy =
  | { kind: "bearer"; token: string }
  | { kind: "dev-headers"; sub: string; email: string }
  | null;

export type ApiClient = Client<paths>;

export function createApiClient(options: {
  baseUrl: string;
  getAuth: () => AuthStrategy | Promise<AuthStrategy>;
}): ApiClient {
  return createClient<paths>({
    baseUrl: options.baseUrl,
    fetch: async (input: Request) => {
      const headers = new Headers(input.headers);
      const auth = await options.getAuth();
      if (auth?.kind === "bearer")
        headers.set("Authorization", `Bearer ${auth.token}`);
      else if (auth?.kind === "dev-headers") {
        headers.set("x-user-sub", auth.sub);
        headers.set("x-user-email", auth.email);
      }
      return fetch(new Request(input, { headers }));
    },
  });
}

/** The `{ error: { code, message } }` body every failure carries. */
export function errorMessage(
  error: unknown,
  fallback = "Something went wrong.",
): string {
  const e = error as { error?: { message?: string } } | undefined;
  return e?.error?.message ?? fallback;
}
